import script from "./UserLagMonitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLagMonitor.vue?vue&type=script&setup=true&lang=ts"

import "./UserLagMonitor.vue?vue&type=style&index=0&id=42221ae7&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42221ae7"]])

export default __exports__